import { render, staticRenderFns } from "./TrangSuaDanhMucHeThong.vue?vue&type=template&id=2d9a4858&"
import script from "./TrangSuaDanhMucHeThong.vue?vue&type=script&lang=js&"
export * from "./TrangSuaDanhMucHeThong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports